import { DetailedHTMLProps, HTMLAttributes } from 'react';

import { merge } from '@/components';
import { Flex } from '@/components/core';

export type PageProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const Page = ({ className, children, ...rest }: PageProps) => {
  return (
    <Flex className="py-lg h-full w-full items-start justify-center overflow-auto bg-gray-50">
      <Flex col className={merge('gap-md w-[40rem]', className)} {...rest}>
        {children}
      </Flex>
    </Flex>
  );
};
